(function() {
  const grid = document.getElementById('our-brands-grid');
  if (!grid) return;

  const buttons = document.querySelectorAll('.brand-alpha-filter__btn[data-letter]');
  const clearBtn = document.getElementById('brand-filter-clear');
  const cards = Array.from(grid.querySelectorAll('.our-brands__card'));

  // 1. Collect all available first letters from cards
  const availableLetters = new Set(cards.map(card => (card.dataset.firstLetter || '').toLowerCase()));

  // 2. Add "disabled" class to buttons that have no brands
  buttons.forEach(btn => {
    const letter = btn.dataset.letter;
    if (!availableLetters.has(letter)) {
      btn.classList.add('disabled');
      btn.setAttribute('aria-disabled', 'true');
    }
  });

  function setActive(letter) {
    buttons.forEach(btn => btn.setAttribute('aria-pressed', btn.dataset.letter === letter ? 'true' : 'false'));

    cards.forEach(card => {
      const first = (card.dataset.firstLetter || '').toLowerCase();
      card.classList.toggle('is-hidden', first !== letter);
    });

    if (clearBtn) clearBtn.style.display = 'inline-block';
  }

  function clearFilter() {
    buttons.forEach(btn => btn.setAttribute('aria-pressed', 'false'));
    cards.forEach(card => card.classList.remove('is-hidden'));
    if (clearBtn) clearBtn.style.display = 'none';
  }

  // Button clicks (ignore disabled ones)
  buttons.forEach(btn => {
    if (!btn.classList.contains('disabled')) {
      btn.addEventListener('click', () => setActive(btn.dataset.letter));
    }
  });
  if (clearBtn) clearBtn.addEventListener('click', clearFilter);

  // Optional: support hash like #brand-letter=C
  const hash = new URLSearchParams(location.hash.replace(/^#/, ''));
  const initial = (hash.get('brand-letter') || '').toLowerCase();
  if (initial && /^[a-z]$/.test(initial) && availableLetters.has(initial)) {
    setActive(initial);
  }

  // Optional: update hash on selection
  function updateHash(letter) {
    const p = new URLSearchParams(location.hash.replace(/^#/, ''));
    if (letter) { p.set('brand-letter', letter); }
    else { p.delete('brand-letter'); }
    const newHash = p.toString();
    if (newHash) location.hash = newHash;
    else history.replaceState(null, '', location.pathname + location.search);
  }
  buttons.forEach(btn => {
    if (!btn.classList.contains('disabled')) {
      btn.addEventListener('click', () => updateHash(btn.dataset.letter));
    }
  });
  if (clearBtn) clearBtn.addEventListener('click', () => updateHash(''));
})();